<div class="row">
  <ng-container *ngFor="let moduleGroup of menulist">
    <ng-container *ngIf="moduleGroup.MODULE_GROUP_ID  != setting.DASHBOARD_MODULE_GROUP_ID">
      <ng-container
        *ngIf="moduleGroup.MODULE_GROUP_ACCESS_STAGE==5 && moduleGroup.MODULE_GROUP_ID == 5 ||  moduleGroup.MODULE_GROUP_ID  == 12">
        <div>
          <a [routerLink]="[moduleGroup.MODULE_GROUP_PATH]" class="router-link-active ex1" href="">
              <span style="background:#ffffff;">
                  <label style="color: #000000">{{ moduleGroup.MODULE_GROUP_NAME }}</label>
                  <div style="text-align: center">
                      <i class="{{ moduleGroup.MODULE_GROUP_ICON }}"
                         style="font-size: 55px;padding-top:10px;background:#ffffff"></i>
                  </div>
                </span>
          </a>
        </div>
      </ng-container>
      <ng-container *ngFor="let module of moduleGroup.sub_menu">
        <ng-container
          *ngIf="module.MODULE_ID !=12 && module.MODULE_ID  != 13 && module.MODULE_ID  != 15 && module.MODULE_ID  != 18 && module.MODULE_ID !=29 && module.MODULE_GROUP_ID  != 6">
          <div>
            <a [routerLink]="[moduleGroup.MODULE_GROUP_PATH + module.MODULE_PATH]" class="router-link-active ex1"
               href="">
              <span style="background:#ffffff;">
                  <label style="color: #000000">{{ module.MODULE_NAME }}</label>
                  <div style="text-align: center">
                      <i class="{{ module.MODULE_ICON }}"
                         style="font-size: 55px;padding-top:10px;background:#ffffff"></i>
                  </div>
                </span>
            </a>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
